export default __webpack_public_path__ + "static/media/Pot1.8d2224bc.svg";